import { isBrowserEnv } from '@visactor/vrender-core';

export const browser = isBrowserEnv();
